import { render, staticRenderFns } from "./port_markers.vue?vue&type=template&id=549a8748&scoped=true&"
import script from "./port_markers.vue?vue&type=script&lang=js&"
export * from "./port_markers.vue?vue&type=script&lang=js&"
import style0 from "./port_markers.vue?vue&type=style&index=0&id=549a8748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a8748",
  null
  
)

export default component.exports